<template lang="pug">
div
  el-card(shadow="hover").espacamento
    div.cardHeader
      b Dados do Cálculo:
    div.center
      el-col(:span='8').flex
        app-display(label="Munícipio:", :content="dadosVtn.municipio.nome" :contentAlignRight="false")
        app-display(label="Valor de referrencia por Ha  :", :content="'R$ ' + formatarValor(dadosVtn.valorReferencia)", :contentAlignRight="false")
        app-display(label="Taxas diversas:", :content="'R$ ' + formatarValor(dadosVtn.taxaDiversa ? (dadosVtn.valorVtn * 0.1) : '0,00')", :contentAlignRight="false")
      el-col(:span='8').flex
        app-display(label="Área requerida:", :content='`${formatarValor(dadosVtn.areaRequerida)} Ha`', :contentAlignRight="false")
        app-display(label="VTN:", :content="'R$ ' + formatarValor(dadosVtn.valorVtn)", :contentAlignRight="false")
        app-display(label="Valor de referência do imóvel:", :content="'R$ ' + formatarValor(dadosVtn.valorReferenciaImovel)", :contentAlignRight="false")
</template>

<script>
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay'
export default {
  components: {
    AppDisplay,
    AppDivider
  },

  props: {
    dadosVtn: {
      type: Object,
      required: true
    }
  },

  methods: {
    formatarValor (valor) {
      return typeof valor === 'string' ? valor : parseFloat(valor).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 13%;
}
.flex {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: inherit;
}

.espacamento {
  margin-top: 3%;
  margin: 20px;
  border-radius: 10px;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

#line {
  width: 100%;
  background-color: gainsboro;
  height: 2px;
  margin-top: 11px;
  margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/ConfirmarDadosMa.vue